module.exports = __webpack_public_path__ + "0462678cb44292303ba4cab4a55027d2.svg";